// Import the functions you need from the SDKs you need
import { initializeApp } from 'firebase/app';
import {
  ReCaptchaEnterpriseProvider,
  initializeAppCheck,
} from 'firebase/app-check';
import { getAuth, connectAuthEmulator } from 'firebase/auth';
import { getFirestore, connectFirestoreEmulator } from 'firebase/firestore';
import { getFunctions, connectFunctionsEmulator } from 'firebase/functions';
import { getStorage, connectStorageEmulator } from 'firebase/storage';

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: 'AIzaSyDYYL_2UDLPTw28rp3OK5UoOBeS5eW4l-o',
  authDomain: 'reckon-ai-e9403.firebaseapp.com',
  projectId: 'reckon-ai-e9403',
  storageBucket: 'reckon-ai-e9403.firebasestorage.app',
  messagingSenderId: '403387915909',
  appId: '1:403387915909:web:473c2ee79ef83a274453ec',
  measurementId: 'G-8Y8P0X95ZN',
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
const db = getFirestore(app);
const functions = getFunctions(app);
const storage = getStorage(app);
// reCAPTCHA site keys are public identifiers. Keep the production key as a
// fallback so direct production builds cannot accidentally omit App Check;
// deployments may still override it for another Firebase web app.
const recaptchaEnterpriseSiteKey = process.env.VUE_APP_RECAPTCHA_ENTERPRISE_SITE_KEY
  || '6Lfh7oItAAAAADsW5X96oJVD1jpEA-4lSehRhh7_';
const appCheck = (() => {
  if (typeof window !== 'undefined' && recaptchaEnterpriseSiteKey) {
    if (process.env.NODE_ENV !== 'production') {
      window.FIREBASE_APPCHECK_DEBUG_TOKEN = true;
    }
    return initializeAppCheck(app, {
      provider: new ReCaptchaEnterpriseProvider(recaptchaEnterpriseSiteKey),
      isTokenAutoRefreshEnabled: true,
    });
  }
  if (typeof window !== 'undefined' && process.env.NODE_ENV !== 'test') {
    console.warn('Vera requires VUE_APP_RECAPTCHA_ENTERPRISE_SITE_KEY before App Check enforcement.');
  }
  return null;
})();

const useFirebaseEmulators = process.env.VUE_APP_USE_FIREBASE_EMULATORS === 'true';

if (
  useFirebaseEmulators
  && typeof window !== 'undefined'
  && ['localhost', '127.0.0.1'].includes(window.location.hostname)
) {
  connectAuthEmulator(auth, 'http://127.0.0.1:9099', { disableWarnings: true });
  connectFirestoreEmulator(db, '127.0.0.1', 8080);
  connectFunctionsEmulator(functions, '127.0.0.1', 5001);
  connectStorageEmulator(storage, '127.0.0.1', 9199);
  console.info('Connected to local Firebase emulators.');
}

export {
  app,
  appCheck,
  auth,
  db,
  functions,
  storage,
};
